export const PAYWALL_DOWNLOAD_BLOCKED_TAG = 'details.paywall.download.blocked';
export const PAYWALL_PRICING_LINK_TAG = 'details.paywall.pricing_link.click';
